import { render, staticRenderFns } from "./UserGroupPage.vue?vue&type=template&id=6597ad15"
import script from "./UserGroupPage.vue?vue&type=script&lang=js"
export * from "./UserGroupPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports